import * as Actions from 'actions/device-management/positions-repository';
import { PositionsFilterFields, PositionWithLevel } from 'models/device-management';
import { Repository } from 'utils/repository';

export type State = Repository<PositionWithLevel, PositionsFilterFields, 'id'>;
const initState: State = Repository.create('id');

export const reducer = (state: State = initState, action: Actions.Action): State => {
  switch (action.type) {
    case Actions.POSITIONS_REPOSITORY_DATA_LOAD_START:
      return state.setFetched(action.params, false);
    case Actions.POSITIONS_REPOSITORY_DATA_LOAD_FAILURE:
      return state.setFetched(action.params, true);
    case Actions.POSITIONS_REPOSITORY_DATA_LOAD_SUCCESS:
      return state
        .setFetched(action.params, true)
        .setData(action.params, action.data);

    default:
      return state;
  }
};
